import i18n from "@/i18n";

/**
 * Format a Stripe minor-unit amount (e.g. pence) as localized currency.
 *
 * Shared by the manage-subscription screen and the in-app checkout summary so
 * the same charge never renders two different ways. Falls back to a plain
 * "9.99 GBP" if the runtime lacks the locale or currency.
 */
export function formatAmount(amount?: number, currency?: string): string {
  if (amount == null || !currency) return "";
  try {
    return new Intl.NumberFormat(i18n.resolvedLanguage, {
      style: "currency",
      currency: currency.toUpperCase(),
    }).format(amount / 100);
  } catch {
    return `${(amount / 100).toFixed(2)} ${currency.toUpperCase()}`;
  }
}
